import React from 'react'
import { components } from 'cng-web-lib'
import { Grid, Tooltip } from '@material-ui/core'
import ProductCondFormProperties from './ProductCondFormProperties'

const {
  button: { CngIconButton }
} = components

const { initialValues } = ProductCondFormProperties.formikProps

function ProductCondEntry(props) {
  const {
    index,
    isLast,
    onAddProdCond,
    onDeleteProdCond,
    prodCondDTO,
    showNotification,
    shouldHideMap
  } = props

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md>
        <ProductCondFormProperties.Fields index={index} showNotification={showNotification} shouldHideMap={shouldHideMap} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddProdCond(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddProdCond({ ...prodCondDTO, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteProdCond(prodCondDTO)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ProductCondEntry
